interface Props {
  color: string;
}

const BorderSpacer = ({ color }: Props) => {
  return (
    <div
      className="h-[1px] w-full opacity-5"
      style={{
        backgroundColor: color,
      }}
    />
  );
};

export default BorderSpacer;
